<template>
  <v-row no-gutters align="center">
    <v-col cols="1" class="pa-0" align="center">
      <mf-icon fill large color="vermelho-l20">warning</mf-icon>
    </v-col>
    <v-col cols="11" class="pa-0 pl-4">
      <span class="warning-text">
        <slot></slot>
      </span>
    </v-col>
  </v-row>
</template>

<script>
export default {}
</script>

<style lang="scss">
.warning-text {
  font-size: 14px;
  letter-spacing: 0.23px;
  line-height: 17px !important;
  color: rgba(0, 0, 0, 0.6) !important;
}
</style>
